import { LandingPageConfig } from 'rangeConfig/@types';
import boaxelGalleryConfig from './boaxelGalleryConfig';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import boaxelOpenDesignImg from '../../views/LandingPage/images/boaxel_landing_open_design.png';
import boaxelBgImage from '../../views/LandingPage/images/boaxel_background.png';

const boaxelLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: boaxelBgImage,
    titleTextColor: '#111111'
  },
  designFromScratch: {
    backgroundColor: '#E1D6D6',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#413F3A',
    backgroundImgUrl: boaxelOpenDesignImg,
    textColor: '#FFFFFF'
  },
  browseInspiration: {
    backgroundColor: '#E6C6AF',
    backgroundImgUrl: '',
    galleryConfig: boaxelGalleryConfig
  }
};

export default boaxelLandingPageConfig;
